module.exports = __webpack_public_path__ + "static/media/hp-hero.f957416e.jpg";